<div class="content-grid-wrapper h-full">
  <div class="col-span-10">
    <app-content-header [title]="dashboardHeaderTitle()" titleClass="text-primaryText"
      [description]="'ADMIN.DASHBOARD.DESCRIPTION' | translate"></app-content-header>
  </div>

  <div class="col-span-10 grid grid-cols-12 gap-(--spacing-layout-l)">
    <div class="col-span-12 flex justify-end items-center">
      <div class="min-w-[220px]">
        @if(filterPeriodValueReady()){
        <app-select [value]="filterPeriodValue" [options]="filterPeriodValues" optionLabel="label" optionValue="value"
          (onChange)="onSelectFilterPeriodValue($event)" [fluid]="true" />
        }
      </div>
    </div>
    <app-a-stats-widget class="contents" [dealsOnly]="isDealsOnlyAdmin()" />
    @if (aiFeatureEnabled) {
    <app-a-ai-summary-widget class="col-span-12" />
    }
    <div class="col-span-12 xl:col-span-6">
      <app-card class="h-full" rootClass="h-full" bodyClass="h-full" contentClass="h-full">
        <div class="flex flex-col h-full">
          <div class="text-subheading-large text-headingText p-5 pt-4 ">Investments</div>
          <div class="p-5 flex-1">
            @if (trendState().loading && !trendState().data) {
              <div class="flex items-center justify-between gap-3 h-[200px]">
                <p-skeleton height="100%" width="1.5rem" />
                <p-skeleton height="100%" width="1.5rem" />
                <p-skeleton height="100%" width="1.5rem" />
                <p-skeleton height="100%" width="1.5rem" />
                <p-skeleton height="100%" width="1.5rem" />
                <p-skeleton height="100%" width="1.5rem" />
                <p-skeleton height="100%" width="1.5rem" />
              </div>
            } @else if (trendState().error) {
            <div class="flex items-center justify-center min-h-[200px] text-bodyText">Failed to load investments trend.</div>
            } @else if (!trendState().data?.series?.length || !trendState().data?.categories?.length) {
            <div class="flex items-center justify-center h-full text-bodyText">No data available</div>
            } @else {
            <app-line-chart [lineData]="lineData"></app-line-chart>
            }
          </div>
        </div>
      </app-card>
    </div>
    <div class="col-span-12 xl:col-span-6">
      <app-revenue-stream-widget
        [title]="revenueByProductTypeState().data?.title ?? 'Revenue Stream'"
        [chartData]="revenueStreamChartData"
        [chartOptions]="revenueStreamChartOptions"
        [loading]="revenueByProductTypeState().loading && !revenueByProductTypeState().data"
        [error]="revenueByProductTypeState().error"
      />
    </div>
    <div class="col-span-12 xl:col-span-6">
      @if (volumeByAssetClassState().loading && !volumeByAssetClassState().data) {
        <app-card class="h-full" rootClass="h-full" bodyClass="h-full" contentClass="h-full">
        <div class="flex justify-between gap-3 w-full h-full min-h-[200px] p-5">
          <div class="flex-1">
            <div class=" flex-1 flex flex-col gap-2">
              <p-skeleton height="1rem" width="100%" />
              <p-skeleton height="1rem" width="100%" />
              <p-skeleton height="1rem" width="100%" />
              <p-skeleton height="1rem" width="100%" />
              <p-skeleton height="1rem" width="100%" />
              <p-skeleton height="1rem" width="100%" />
            </div>
          </div>
          <div class=" flex-1 flex flex-col gap-2">
            <p-skeleton height="1rem" width="100%" />
            <p-skeleton height="1rem" width="100%" />
            <p-skeleton height="1rem" width="100%" />
            <p-skeleton height="1rem" width="100%" />
            <p-skeleton height="1rem" width="100%" />
            <p-skeleton height="1rem" width="100%" />
          </div>
        </div>
        </app-card>
      } @else if (volumeByAssetClassState().error) {
        <app-card class="h-full" rootClass="h-full" bodyClass="h-full" contentClass="h-full">
          <div class="flex items-center justify-center h-full text-bodyText">Failed to load volume by asset class.</div>
        </app-card>
      } @else {
      <app-best-selling-widget
      [title]="volumeByAssetClassState().data?.title ?? 'Total Investment Volume'"
      [items]="(volumeByAssetClassState().data?.items ?? []).map(i => ({ label: i.label, icon: volumeByAssetClassIconByKey(i.key), percentage: i.percentage }))"
    />
      }
    </div>

    @if (!isDealsOnlyAdmin()) {
    <div class="col-span-12 xl:col-span-6">
      <app-card class="h-full" rootClass="h-full">
        <div class="flex flex-col">
          <div class="text-subheading-large text-headingText p-5 pt-4 ">Wealth Manager Onboarding Status</div>
          <div class="p-5">
            @if (wmOnboardingStatusState().loading && !wmOnboardingStatusState().data) {
            <div class="flex items-center justify-between gap-3 w-full h-full min-h-[200px]">
              <div class="flex-1">
                <p-skeleton shape="circle" size="15rem" />
              </div>
              <div class=" flex-1 flex flex-col gap-2">
                <p-skeleton height="0.875rem" width="100%" />
                <p-skeleton height="0.875rem" width="100%" />
                <p-skeleton height="0.875rem" width="100%" />
                <p-skeleton height="0.875rem" width="100%" />
              </div>
            </div>
            } @else if (wmOnboardingStatusState().error) {
            <div class="flex items-center justify-center min-h-[200px] text-bodyText">Failed to load status.</div>
            } @else if (!wmOnboardingStatusState().data?.slices?.length) {
            <div class="flex items-center justify-center min-h-[200px] text-bodyText">No data available</div>
            } @else {
            <app-doughnut-chart [data]="doughnutChartData"></app-doughnut-chart>
            }
          </div>
        </div>
      </app-card>
    </div>
    <div class="col-span-12 xl:col-span-6">
      <app-card class="h-full" rootClass="h-full" contentClass="h-full" bodyClass="h-full">
        <div class="flex flex-col h-full">
          <div class="text-subheading-large text-headingText p-5 pt-4 shrink-0">User Type</div>
          <div class="p-5 flex-1">
            @if (applicantTypesState().loading && !applicantTypesState().data) {
            <div class="flex items-center justify-between gap-3 h-[200px]">
              <p-skeleton height="100%" width="1.5rem" />
              <p-skeleton height="100%" width="1.5rem" />
              <p-skeleton height="100%" width="1.5rem" />
              <p-skeleton height="100%" width="1.5rem" />
              <p-skeleton height="100%" width="1.5rem" />
              <p-skeleton height="100%" width="1.5rem" />
              <p-skeleton height="100%" width="1.5rem" />
            </div>
            } @else if (applicantTypesState().error) {
            <div class="flex items-center justify-center min-h-[200px] text-bodyText">Failed to load applicant types.
            </div>
            } @else if (!applicantTypesState().data?.labels?.length || !applicantTypesState().data?.series) {
            <div class="flex h-full items-center justify-center text-bodyText">No data available</div>
            } @else {
            <app-bar-chart [barChartData]="barData"></app-bar-chart>
            }
          </div>
        </div>
      </app-card>
    </div>
    }


    <div class="col-span-12 xl:col-span-6">
      <app-notifications-widget class="h-full"/>
    </div>
  </div>
</div>